<template>
  <section class="section">
    <div v-if="approved" class="container">
      <b-notification
        type="is-success"
        has-icon
        class="d-flex justify-content-center align-items-center"
        :closable="false"
      >
        <p>Your email has been successfully verified!</p>
      </b-notification>
    </div>
  </section>
</template>

<script>
import studentService from '../services/student.service';

export default {
  name: 'AcceptApproval',
  data() {
    return {
      approved: false,
    };
  },
  async created() {
    await this.approveEmail();
  },
  methods: {
    async approveEmail() {
      const urlStudentId = this.$route.query.studentId;

      if (urlStudentId) {
        await studentService.approveStudentEmail({
          studentId: urlStudentId,
        });
        this.approved = true;
      }
    },
  },
};
</script>

<style>
.notification .media {
  align-items: center;
}
</style>
